import { logFrontendError } from '../services/auditTrail-service';

const originalConsoleError = console.error.bind(console);

let initialized = false;

// Patterns that indicate React warnings/dev messages, not actual errors
const IGNORE_PATTERNS = [
  'Warning:',
  'React does not recognize',
  'Invalid DOM property',
  'Each child in a list',
  'Failed prop type',
  'componentWillReceiveProps',
  'componentWillMount',
  'findDOMNode is deprecated',
  'Cannot update a component',
  'Can\'t perform a React state update'
];

export function initErrorLogger() {
  if (initialized) return;
  initialized = true;

  // Override console.error - only log actual errors, skip React warnings
  console.error = function (...args) {
    originalConsoleError(...args);

    try {
      // Skip React dev warnings
      const firstArg = args[0];
      if (typeof firstArg === 'string') {
        for (const pattern of IGNORE_PATTERNS) {
          if (firstArg.includes(pattern)) return;
        }
      }

      let message = '';
      let stack = '';
      let fileName = '';
      let lineNumber = '';

      for (const arg of args) {
        if (arg instanceof Error) {
          message = arg.message;
          stack = arg.stack || '';
        } else if (typeof arg === 'string') {
          message = message ? `${message} ${arg}` : arg;
        } else if (typeof arg === 'object' && arg !== null) {
          if (arg.message) message = message || arg.message;
          if (arg.stack) stack = stack || arg.stack;
        }
      }

      if (!message && args.length > 0) {
        message = String(args[0]).substring(0, 500);
      }

      // Extract file/line from stack
      if (stack) {
        const lines = stack.split('\n');
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i];
          if (line.includes('errorLogger')) continue;
          const parenIdx = line.lastIndexOf('(');
          const segment = parenIdx !== -1 ? line.substring(parenIdx + 1).replace(')', '') : line.trim();
          const parts = segment.split(':');
          if (parts.length >= 3) {
            parts.pop();
            lineNumber = parts.pop();
            fileName = parts.join(':');
            if (lineNumber && /^\d+$/.test(lineNumber)) break;
            fileName = '';
            lineNumber = '';
          }
        }
      }

      const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');

      logFrontendError({
        source: 'frontend',
        fileName,
        lineNumber,
        message: message.substring(0, 1000),
        stack: stack.substring(0, 3000),
        userId: userData.userId || '',
        url: window.location.href,
        userAgent: navigator.userAgent
      });
    } catch {
      // Silently fail
    }
  };

  // Global unhandled error (these are always real errors)
  window.addEventListener('error', (event) => {
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
    logFrontendError({
      source: 'frontend',
      fileName: event.filename || '',
      lineNumber: String(event.lineno || ''),
      message: event.message || 'Unhandled error',
      stack: event.error?.stack || '',
      userId: userData.userId || '',
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  });

  // Unhandled promise rejection (these are always real errors)
  window.addEventListener('unhandledrejection', (event) => {
    const userData = JSON.parse(sessionStorage.getItem('userData') || '{}');
    const reason = event.reason;
    logFrontendError({
      source: 'frontend',
      fileName: '',
      lineNumber: '',
      message: reason?.message || String(reason || 'Unhandled promise rejection'),
      stack: reason?.stack || '',
      userId: userData.userId || '',
      url: window.location.href,
      userAgent: navigator.userAgent
    });
  });
}
